import { DEBOUNCE_MS, debounce } from "../core/dom.js";
import type { SlaterList } from "../list.js";

/**
 * Search filtering — the in-list keyword box: `[data-slater-search]` pointed at
 * a `data-slater-list`. Queries the whole collection, relevance-ranked, and
 * combines with active filters (AND). The same attribute on a search block is
 * bound by global-search/ instead — the wrapper's mode picks the binder.
 */
export function bindListSearchInput(list: SlaterList): void {
  for (const input of list.scoped("[data-slater-search]")) {
    const run = debounce(() => {
      const raw = (input as HTMLInputElement).value.trim();
      list.state.q = raw;
      list.resetAndLoad();
    }, DEBOUNCE_MS);
    input.addEventListener("input", run);
  }
}
